var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-modal",class:{ 'my-modal_top-index': !_vm.$store.state.isAuthenticated }},[_c('div',{staticClass:"my-modal__dialog"},[(_vm.noContainer)?_c('div',{staticClass:"my-modal__outer"},[_vm._t("default")],2):_c('div',{staticClass:"my-modal__content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }